/* AURO free gifts: adds/removes gift items at checkout so the automatic
   Buy-X-Get-Y discounts can apply. Thresholds in cents (AUD). */
(function () {
  var GIFTS = [
    { id: 49051934490843, min: 10000 }, /* Ankle compression sleeves S/M - spend $100 */
    { id: 50516721795291, min: 15000 }  /* 3D sleep mask - spend $150 */
  ];
  var GIFT_IDS = GIFTS.map(function (g) { return g.id; });
  var ALT_IDS = [50516721959131]; /* other sizes of the gift sleeves */
  function isGift(it) { return GIFT_IDS.indexOf(it.variant_id) > -1 || ALT_IDS.indexOf(it.variant_id) > -1; }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  }
  function sync() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var spend = 0;
      cart.items.forEach(function (it) { if (!isGift(it)) spend += it.final_line_price; });
      var chain = Promise.resolve();
      GIFTS.forEach(function (g) {
        var line = cart.items.filter(function (it) { return it.variant_id === g.id || (g.id === GIFT_IDS[0] && ALT_IDS.indexOf(it.variant_id) > -1); })[0];
        var auto = line && line.properties && line.properties._auro_gift;
        if (spend >= g.min && !line) {
          chain = chain.then(function () { return post('/cart/add.js', { items: [{ id: g.id, quantity: 1, properties: { _auro_gift: 'yes' } }] }); });
        } else if (spend < g.min && line && auto) {
          chain = chain.then(function () { return post('/cart/change.js', { id: line.key, quantity: 0 }); });
        }
      });
      return chain;
    }).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[name="checkout"], a[href^="/checkout"], button[form][name="checkout"], .cart__checkout-button, [data-checkout]');
    if (!el || el.dataset.auroGiftDone) return;
    e.preventDefault(); e.stopPropagation();
    el.dataset.auroGiftDone = '1';
    sync().then(function () { window.location.href = '/checkout'; });
  }, true);
})();

/* AURO product page art: fills blank "How it works" and feature slots with
   the matching photos from Files (auro-<prefix>-s1..s3 / f1..f2.png).
   Only replaces the placeholder drawings - images picked in the theme editor win. */
(function () {
  var MAP = {
    'travel-wallet': 'auro-wal', 'seat-cushion': 'auro-cus', 'vacuum-travel-bag': 'auro-vac',
    'packing-cubes': 'auro-stk', 'anti-theft-backpack': 'auro-bp', 'anti-theft-sling-bag': 'auro-sl',
    'bluetooth-sleep-mask': 'auro-bt', '3d-sleep-mask': 'auro-m3', 'ankle-compression-sleeves': 'auro-sv',
    'travel-pillow': 'auro-pil'
  };
  var SWAP = { 'auro-vac-s3': 'auro-vac-g4', 'auro-m3-f1': 'auro-m3-s2', 'auro-m3-f2': 'auro-m3-s1', 'auro-sv-f1': 'auro-sv-s1', 'auro-sv-f2': 'auro-sv-s2' };
  function run() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    var p = m && MAP[m[1]];
    var style = document.createElement('style');
    style.textContent = '.pm-thumbs .ph{display:none!important}.pm-step .art img,.pm-feat .art img{width:100%;height:100%;object-fit:cover;display:block}'
      + '.pm .pm-logo{content:url("/cdn/shop/files/auro-logo-riviera.png?v=1790331915")!important}'
      + '.pm-card.rv-img{padding:0;border:0;border-radius:16px;overflow:hidden;background:#fff;box-shadow:0 18px 40px -26px rgba(47,58,43,.55);transition:transform .25s ease}'
      + '.pm-card.rv-img:hover{transform:translateY(-3px)}'
      + '.pm-card.rv-img .rv-ph{position:relative;aspect-ratio:4/3;overflow:hidden;background:#e6ded1}'
      + '.pm-card.rv-img .rv-ph img{width:100%;height:100%;object-fit:cover;display:block}'
      + '.pm-card.rv-img .rv-ph:after{content:"";position:absolute;inset:0;background:linear-gradient(180deg,rgba(47,58,43,0) 55%,rgba(47,58,43,.35))}'
      + '.pm-card.rv-img .rv-n{position:absolute;z-index:1;top:14px;left:14px;background:#2f3a2b;color:#f3efe8;font-size:11px;font-weight:700;letter-spacing:.14em;padding:6px 10px;border-radius:999px}'
      + '.pm-card.rv-img .rv-bd{padding:22px 24px 26px;border-top:3px solid #b5653a}'
      + '.pm-card.rv-img h3{font-size:19px;margin-bottom:8px}.pm-card.rv-img p{font-size:15px;line-height:1.6}';
    document.head.appendChild(style);
    if (!p) return;
    function put(el, key, w, alt) {
      if (!el) return;
      var svg = el.querySelector(':scope > svg');
      if (!svg) return;
      var name = SWAP[p + '-' + key] || (p + '-' + key);
      var img = new Image();
      img.alt = alt || '';
      img.src = '/cdn/shop/files/' + name + '.png?width=' + w;
      img.onload = function () { svg.replaceWith(img); };
    }
    document.querySelectorAll('.pm-card').forEach(function (c, i) {
      if (i > 2) return;
      var ic = c.querySelector(':scope > .ic');
      if (!ic) return;
      var img = new Image();
      img.alt = (c.querySelector('h3') || {}).textContent || '';
      img.src = '/cdn/shop/files/' + p + '-p' + (i + 1) + '.png?width=800';
      img.onload = function () {
        var ph = document.createElement('div'); ph.className = 'rv-ph';
        var n = document.createElement('span'); n.className = 'rv-n'; n.textContent = '0' + (i + 1);
        ph.appendChild(n); ph.appendChild(img);
        var bd = document.createElement('div'); bd.className = 'rv-bd';
        while (ic.nextSibling) bd.appendChild(ic.nextSibling);
        ic.replaceWith(ph); c.appendChild(bd); c.classList.add('rv-img');
      };
    });
    document.querySelectorAll('.pm-step').forEach(function (s, i) {
      if (i < 3) put(s.querySelector('.art'), 's' + (i + 1), 900, (s.querySelector('h3') || {}).textContent);
    });
    document.querySelectorAll('.pm-feat').forEach(function (f, i) {
      if (i < 2) put(f.querySelector('.art'), 'f' + (i + 1), 1000, (f.querySelector('h3') || {}).textContent);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
